export enum EagerLoadingMethod {
  withGraphJoined = 'withGraphJoined',
  withGraphFetched = 'withGraphFetched',
}
